import '../style/Partners.css';

const partners = [
  { name: 'TRA', file: 'TRA.png' },
  { name: 'TPA', file: 'tpa.webp' },
  { name: 'TEAGT', file: 'teagt.png' },
  { name: 'USA Embassy', file: 'usaa.png' },
  { name: 'LATRA', file: 'latra.jpeg' },
];

export default function Partners() {
  const loopPartners = [...partners, ...partners];

  return (
    <section className="Partners" aria-label="Our partners">
      <div className="Partners-inner">
        <h2 className="Partners-title">Our Clients</h2>

        <div className="Partners-carousel" aria-label="Partners logo carousel">
          <div className="Partners-track">
            {loopPartners.map((partner, idx) => (
              <article key={`${partner.name}-${idx}`} className="Partners-card">
                <img
                  className="Partners-logo"
                  src={`${process.env.PUBLIC_URL}/image/${partner.file}`}
                  alt={`${partner.name} logo`}
                  loading="lazy"
                />
                <p className="Partners-name">{partner.name}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

